import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { NoDataComponent, TwoGridSkeleton } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/common';
import { FormContainer, Separator } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/styles';
import { StyledTypography } from 'styles/common';

import { getSurvey } from 'services/engagement';
import { showErrorSnackbar } from 'services/snackbar';

const getDisplayData = (data) => ({
  'Survey name': data.name,
  Drivers: data.surveyDrivers.map((item) => item.displayName).join(', '),
});

const NameSummary = ({ formId }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = () => {
    getSurvey({ surveyId: formId })
      .then((res) => setData(res))
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to fetch the reminders!'));
      })
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  const displayData = data ? getDisplayData(data) : null;

  return (
    <FormContainer>
      <StyledTypography color="#333" weight={600}>
        Summary
      </StyledTypography>
      <Separator />
      {loading ? (
        <TwoGridSkeleton />
      ) : (
        <>
          {displayData ? (
            Object.keys(displayData).map((key, i) => (
              <>
                <Grid container>
                  <Grid xs={6}>
                    <StyledTypography color="#888">{key}</StyledTypography>
                  </Grid>
                  <Grid xs={6}>
                    <StyledTypography color="#333">{displayData[key]}</StyledTypography>
                  </Grid>
                </Grid>
                {i < Object.keys(displayData).length - 1 && <Separator />}
              </>
            ))
          ) : (
            <NoDataComponent />
          )}
        </>
      )}
    </FormContainer>
  );
};

export default NameSummary;
